module.exports = __webpack_public_path__ + "assets/landscape-review.18e63035.svg";